// @flow
import {create, type Jss} from 'jss'
import preset from 'jss-preset-default'

const jss: Jss = create(preset())
export default jss
